module.exports = __webpack_public_path__ + "img/پاکت-گرافت.6719aecd.png";